import { FACompDetailsType } from "./../../types/blog/blogContentTypes";
import {
  filterCompRoundDetails,
  getFAComp,
  getFACompByType,
} from "./../filters/filterPostsRefData";
import { FACompsBySeasonDate } from "./postReferenceData";
import { FACompBlogContentType } from "../../types/blog/blogContentTypes";

export const generateCompBlogPost = (
  season: string,
  compName: string,
  roundName: string
): FACompBlogContentType | null => {
  let compRoundDetails: FACompDetailsType | null = filterCompRoundDetails(
    season,
    compName,
    roundName
  );
  if (compRoundDetails === null) return null;
  let generateCompBlogPost: FACompBlogContentType = {
    season: compRoundDetails.season,
    comp: compRoundDetails.comp,
    roundName: compRoundDetails.roundName,
    roundDate: compRoundDetails.roundDate,
    noOfTies: compRoundDetails.noOfTies,
    winnerPrizeMoney: compRoundDetails.winnerPrizeMoney,
    loserPrizeMoney: compRoundDetails.loserPrizeMoney,
    matchList: compRoundDetails.matchList,
    otherText: compRoundDetails.otherText,
    isPublished: false,
    title: "",
    pubDate: "",
    modifiedDate: "",
    excerpt: "",
    categories: getFACompByType(compRoundDetails.comp)!.categories,
    content: "",
  };
  return generateCompBlogPost;
};
